module.exports = __webpack_public_path__ + "media/images/pokerroom/888/join-bg-9c6e3b77a9312649589f35d9894028c1.jpg";